import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { spacing12 } from 'approot/shared/styles/spacing.style';
import { baseFlexCss } from 'approot/shared/styles/flex.style';
import { baseHeaderStyles, HeaderLogoStyled } from '../../header/header.style';

type NavHeaderGuestContainerProps = {
  top: number;
};
export const NavHeaderGuestContainer = styled.header<
  NavHeaderGuestContainerProps
>`
  ${baseHeaderStyles}
`;

export const NavHeaderGuestInner = styled.div`
  ${baseFlexCss}
  height: ${rem(40)};
  position: relative;
  width: 100%;
`;

export const NavHeaderGuestRight = styled.div`
  ${baseFlexCss}
  gap: ${rem(spacing12)};
`;

export const NavHeaderGuestLeft = styled.div`
  ${baseFlexCss}
  gap: ${rem(spacing12)};

  ${HeaderLogoStyled} {
    position: relative;
  }
`;
